import React, {useEffect, useState} from 'react';
import {Dimensions, FlatList, StyleSheet, View, Image, TouchableOpacity} from 'react-native';
import {Badge, Col, Container, Row, Button} from 'react-bootstrap';
import {Card, Text} from 'react-native-elements';
import {toast} from 'react-toastify';
import HomeHeader from '../../components/HomeHeader';
import Loading from '../../components/Loading';
import {getBouquesForAccount, getGenreWiseChannelsByBouquet, getPricesofSelectedBouques} from '../../network/Network';
import Modal from 'react-bootstrap/Modal';
import Accordion from 'react-bootstrap/Accordion';
import Spinner from 'react-bootstrap/Spinner'
import CheckoutFooter from '../../components/CheckoutFooter';
import { getCartItems } from '../../database/DataBase';

const WIDTH = Dimensions.get('window').width;
const HEIGHT = Dimensions.get('window').height;
const isWeb = WIDTH > 992;

export default function Bouques(props) {

  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [channelList, setChannelList] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [activePacks, setActivePacks] = useState([]);
  const [upcomingPacks, setUpcomingPacks] = useState([]);
  const [hasActiveBasePack, setHasActiveBasePack] = useState(false);
  const [selectedPackIds, setSelectedPackIds] = useState([]);
  const [cart, setCart] = useState([]);
  const [isCartUpdated, setIsCartUpdated] = useState(false);

  useEffect(() => {
    getBouquesForAccount()
      .then((json) => {
        if (json.success === true && json.status === 200) {
          const active = [];
          const upcoming = [];
          json.data.forEach(element => {
            if(element.bouque_type != 0){
              if(new Date().getTime() > new Date(element.activation_date).getTime()){
                active.push(element);
              } else{
                upcoming.push(element);
              }
            }
          });
          upcoming.forEach(ele => {
            if(ele.bouque_type == 1){
              if(new Date().getTime() < new Date(ele.deactivation_date).getTime()){
                setHasActiveBasePack(true);
              }
            }
          });
          setActivePacks(active);
          setUpcomingPacks(upcoming);
          setLoading(false);
          getCartItems()
            .then((items) => {
              setIsCartUpdated(true);
              if(Array.isArray(items)){
                const ids = [];
                items.forEach((obj) => {
                  ids.push(obj.id);
                });
                setSelectedPackIds(ids);
                setCart(items);
              }
            });
        }
      })
      .catch((e) => {
        console.log(e);
        toast('Error, please try again');
        setLoading(false);
      });
  }, []);

  const openModal = (bouque_id) => {
    setShow(true);
    setModalLoading(true);
    getGenreWiseChannelsByBouquet(bouque_id)
      .then((json) => {
        setChannelList(json.data.channels);
        setModalLoading(false);
      });
  }

  const closeModal = () => {
    setShow(false);
  }

  const getBouqueNameFromType = (type) => {
    switch (type) {
      case 0:
        return 'NCF';
      case 1:
        return 'BASE';
      case 2:
        return 'ADDON';
      case 3:
        return 'ALACARTE';
      default:
        return;
    }
  };
  
  const getBadgeVariantFromType = (type) => {
    switch (type) {
      case 0:
        return 'warning';
      case 1:
        return 'danger';
      case 2:
        return 'primary';
      case 3:
        return 'success';
      default:
        return;
    }
  };

  const selectThisPack = (item) => {
    let arr = [...selectedPackIds];
    let tempCart = [...cart];
    if(arr.includes(item.bouque_id)){
      arr.splice(arr.indexOf(item.bouque_id), 1);
      let index = 0; let myIndex = -1;
      tempCart.forEach((ele) => {
        if(ele.id == item.bouque_id){
          myIndex = index;
        }
        index++;
      });
      if(myIndex != -1){
        tempCart.splice(myIndex, 1);
      }
    } else{
      arr.push(item.bouque_id);
      const obj = {
        id: item.bouque_id,
        pack_name: item.name,
        pack_type: getBouqueNameFromType(item.bouque_type),
        mrp: item.mrp
      };
      tempCart.push(obj);
    }
    setSelectedPackIds(arr);
    setCart(tempCart);
  }

  const selectAllPacks = () => {
    let arr = [];
    let tempCart = [];
    activePacks.map((item) => {
      arr.push(item.bouque_id);
      tempCart.push({
        id: item.bouque_id,
        pack_name: item.name,
        pack_type: getBouqueNameFromType(item.bouque_type),
        mrp: item.mrp
      });
    });
    setSelectedPackIds(arr);
    setCart(tempCart);
  }

  const unselectAllPacks = () => {
    setSelectedPackIds([]);
    setCart([]);
  }

  const formatDate = (str) => {
    let d = new Date(str);
    return d.getDate()+"/"+(d.getMonth()+1)+"/"+d.getFullYear();
  }

  const calculateNumOfColumns = () => {
    if(isWeb){
      return Math.round((WIDTH - 128)/350)
    } else{
      return Math.round(WIDTH/350);
    }
  }

  const keyExtractor = (item, index) => index.toString();

  const renderItem = ({item, index}) => {
    const isSelected = selectedPackIds.includes(item.bouque_id);
    const shadowColor = isSelected ? `${0}px ${0}px ${12}px ${'#3C7F0EBB'}` : `${0}px ${0}px ${12}px ${'#8080803B'}`;
    return (
      <Card containerStyle={[styles.cardContainerStyle, {boxShadow: shadowColor}]}>
        <Card.Title style={styles.cardTitleStyle}>
          {item.name}
          <TouchableOpacity
            onPress={() => openModal(item.bouque_id)}>
            <Image source={process.env.PUBLIC_URL + '/assets/info.png'} style={styles.info} />
          </TouchableOpacity>
        </Card.Title>
        <View style={styles.priceViewStyle}>
          <Text style={styles.priceTextStyle}>Rs.{parseFloat(item.mrp).toFixed(2)}/-</Text>
          <Badge
            style={{alignSelf: 'center'}}
            variant={getBadgeVariantFromType(item.bouque_type)}>
            {getBouqueNameFromType(item.bouque_type)}
          </Badge>
        </View>
        <View style={styles.priceViewStyle}>
          <View>
            <Text style={styles.textStyle}>Expiry Date</Text>
            <Text style={styles.textHeaderStyle}>
              {formatDate(item.deactivation_date)}
            </Text>
          </View>
          <View>
            <Text style={styles.textStyle}>Days Left</Text>
            <Text style={styles.textHeaderStyle}>
              {item.left}
            </Text>
          </View>
        </View>
        <View style={{ flexDirection: 'row' }}>
          <Button 
            style={{flex: 1, marginRight: 4}} 
            variant="primary" 
            onClick={() => openModal(item.bouque_id)}>
            View Channels
          </Button>
          {
            (item.bouque_type == 1 && hasActiveBasePack)
            ?
              <></>
            : (
              isSelected 
                ? <Button 
                    variant="success" 
                    style={{ flex: 1, marginLeft: 4, backgroundColor: '#3C7F0E', borderColor: '#3C7F0E' }}
                    onClick={() => selectThisPack(item)}>Selected</Button>
                : <Button 
                    variant="outline-light" 
                    style={{ flex: 1, marginLeft: 4 }}
                    onClick={() => selectThisPack(item)}>Select</Button> 
            )
          }
        </View>
      </Card>
    );
  }

  const renderChannelCard = ({item, index}) => {
    return (
      <View style={{ elevation: 8, borderWidth: 1, borderColor: 'grey', borderRadius: 8, flexDirection: 'column', margin: 8, padding: 8, width: isWeb ? '17%' : '45%', }}>
        {/* <Image source={{ uri: item.logo_url }} style={{ height: 90, width: 90}}/> */}
        <Text style={{ flex:1 }}>{item.name}</Text>
      </View>
    );
  }

  return (
    <>
      <View style={styles.container}>
        <HomeHeader navigation={props.navigation} />
        {loading ? (
          <View style={styles.indicatorViewStyle}>
            <Loading />
          </View>
        ) : (
          <View style={{ flexDirection: 'column', paddingBottom: 120, marginHorizontal: isWeb ? 64 : 16}}>
            <View>
              <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 16, marginStart: 8, marginEnd: 8 }}>
                <Text style={{ color: 'white', fontSize: 24, fontWeight: 'bold' }}>{'Active Packs'}</Text>
                {
                  activePacks.length == cart.length ? (
                    <Button
                      variant="danger"
                      onClick={() => unselectAllPacks()}>Unselect All</Button>
                  ) : (
                    <Button
                      variant="outline-light"                    
                      onClick={() => selectAllPacks()}>Select All</Button>
                  )
                }
              </View>
              <FlatList
                style={{ alignSelf: 'center' }}
                data={activePacks}
                keyExtractor={keyExtractor}
                renderItem={renderItem}
                numColumns={calculateNumOfColumns()}
                extraData={selectedPackIds}
              />
            </View>
            {upcomingPacks.length > 0 && (
              <View>
                <Text style={{ color: 'white', fontSize: 24, fontWeight: 'bold', marginTop: 16, marginStart: 8}}>{'Upcoming Packs'}</Text>
                <FlatList
                  style={{ alignSelf: upcomingPacks.length < calculateNumOfColumns() ? 'auto' : 'center' }}
                  data={upcomingPacks}
                  keyExtractor={keyExtractor}
                  renderItem={renderItem}
                  numColumns={calculateNumOfColumns()}
                />
              </View>
            )}
          </View>
        )}
        <CheckoutFooter
          show={cart.length > 0} 
          cartItems={cart}
          isCartUpdated={isCartUpdated}
          periodId={'2'}/>
      </View>
      <Modal
        show={show}
        size="lg"
        centered
        onHide={() => {closeModal()}}>
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalLoading ? (
            <View style={{ alignItems: 'center', justifyContent: 'center' }}>
              <Spinner animation="border" />
              <Text>Loading...</Text>
            </View>
          ) : (
            <Accordion defaultActiveKey="0">
              {
                channelList.map((obj) => {
                  return (
                    <Card key={obj.genre_id}>
                      <Accordion.Toggle as={Button} variant="Button" eventKey={obj.genre_id}>
                        {obj.genre_name}
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey={obj.genre_id}>
                        <FlatList
                          data={obj.channel_list}
                          keyExtractor={keyExtractor}
                          renderItem={renderChannelCard}
                          numColumns={isWeb ? 5 : 2}
                        />
                      </Accordion.Collapse>
                    </Card>
                  );
                })
              }
            </Accordion>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => {
            closeModal()
          }}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

const styles = StyleSheet.create({
  viewStyle: {
    width: WIDTH
  },
  container: {
    height: HEIGHT,
  },
  indicatorViewStyle: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  cardContainerStyle: {
    marginHorizontal: 8,
    width: 290,
    elevation: 8,
    borderWidth: 0,
    borderRadius: 8,
    backgroundColor: 'black',
  },
  cardTitleStyle: {
    color: 'white',
    fontSize: 15,
    textTransform: 'uppercase',
    fontFamily: 'Source Sans Pro, sans-serif',
    fontWeight: 'normal',
    justifyContent: 'center'
  },
  priceViewStyle: {
    marginBottom: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  priceTextStyle: {
    fontSize: 18,
    color: 'silver',
    fontWeight: 'bold',
    fontFamily: 'Source Sans Pro, sans-serif',
  },
  textStyle: {
    fontSize: 12,
    color: 'grey',
    fontFamily: 'Source Sans Pro, sans-serif',
    fontWeight: 'normal',
  },
  textHeaderStyle: {
    fontSize: 15,
    color: 'orange',
    fontFamily: 'Source Sans Pro, sans-serif',
    fontWeight: 'normal',
  },
  packExpiresTextStyle: {
    marginBottom: 10,
    fontSize: 11,
    fontStyle: 'italic',
    color: 'silver',
    fontFamily: 'Source Sans Pro, sans-serif',
    fontWeight: 'normal',
  },
  info: {
    width: 16,
    height: 16,
    marginLeft: 8,
  }  
});
